import React from "react";
import Navbar from "../components/navbar/desktop";
import { Container } from "@material-ui/core";
import DesktopFooter from "../components/footer/desktop";
import { graphql } from "gatsby";
import Seo from "../components/seoHead";

export default function TermsPolicy({ data }) {
  React.useEffect(() => {
    // When the mobile header is close, we want a un-fixed body
    const scrollY = document.body.style.top;
    document.body.style.position = "";
    document.body.style.top = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
  }, []);

  return (
    <>
      <Seo data={data?.seoData?.page?.seo} link={data?.seoData?.page?.link} />
      <Navbar />
      <main style={{ paddingTop: 125 }}>
        <Container>
          <div
            dangerouslySetInnerHTML={{ __html: data?.seoData?.page?.content }}
          />
        </Container>
      </main>
      <DesktopFooter bg={"transparent"} />
    </>
  );
}

export const pageQuery = graphql`
  query {
    seoData: vglwpgraphql {
      page(id: "787", idType: DATABASE_ID) {
        seo {
          canonical
          metaDesc
          title
          schema {
            raw
          }
          twitterDescription
          twitterTitle
          twitterImage {
            mediaItemUrl
          }
          opengraphUrl
          opengraphType
          opengraphTitle
          opengraphPublishedTime
          opengraphModifiedTime
          opengraphImage {
            mediaItemUrl
          }
          metaRobotsNoindex
          metaRobotsNofollow
          metaKeywords
          opengraphDescription
        }
        link
        content
      }
    }
  }
`;
